module.exports = __webpack_public_path__ + "static/media/clipboard-list.5648b145.svg";